import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedName from 'I18n/components/FormattedName';
import formatName from 'I18n/utils/formatName';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function UserName({
  user
}) {
  const {
    firstName,
    lastName,
    email
  } = user;
  const formattedName = formatName({
    firstName,
    lastName,
    email
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: firstName || lastName ? /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      children: /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(Text, {
          as: "span",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "app-governance-lib.modal.userNameWithEmail",
            options: {
              formattedName: /*#__PURE__*/_jsx("b", {
                children: formattedName
              }),
              email
            }
          })
        })
      })
    }) : /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(FormattedName, {
        email: email
      })
    })
  });
}